import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 15 15"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", {
      fill: "none",
      "fill-rule": "evenodd",
      stroke: "#F9626B",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.2"
    }, [
      _createElementVNode("path", { d: "M7.5 14a6.5 6.5 0 1 0 0-13 6.5 6.5 0 0 0 0 13M12 3l-9 9" })
    ], -1)
  ]))]))
}
export default { render: render }